import {StatusDTO} from "./statusDTO.interface";

export interface BaseDTO {
  id?: string;
  statusId?: number;
  status?: StatusDTO;
  added?: Date;
  updated?: Date;
}
